import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@stimulus/polyfills';
import 'custom-event-polyfill/polyfill';
import 'classlist-polyfill';
